<script>
export default {
  props: {
    title: {
      type: String,
      default: undefined
    }
  },

  methods: {
    add() {
      this.$emit('add')
    }
  },

  render() {
    return (
      <div>
        <div class={this.$style.header}>
          <el-row
            type="flex"
            gutter={16}
            align="middle"
            style={{ flexWrap: 'wrap' }}
          >
            <el-col span={null} style={{ flex: '1' }}>
              <h2 class={this.$style.title}>{this.title}</h2>
            </el-col>
            <el-col span={null}>
              <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                onClick={this.add}
              >
                เพิ่มรายการ
              </el-button>
            </el-col>
          </el-row>
        </div>
        <ol class={this.$style.list}>{this.$slots.default}</ol>
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.header {
  margin-bottom: 1.5rem;
}

.title {
  font-weight: bold;
  margin: 0;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
